import React, { useState } from 'react';
import { BanjoString, useBanjo } from '@stashinvest/react-banjo';
import { LinkItem, PartialSheet, Text } from '@stashinvest/react-components';
import { Flex, Image } from '@stashinvest/ui';
import CheckExample from 'stash/assets/link-bank/check-example.min.svg';

const CheckExamplePartialSheet = () => {
	const { getString } = useBanjo();
	const [showPartialSheet, setShowPartialSheeet] = useState(false);
	const togglePartialSheet = (e) => {
		if (!showPartialSheet) {
			e.preventDefault();
		}
		setShowPartialSheeet((prevState) => !prevState);
	};

	return (
		<>
			<LinkItem
				className="mb-layoutXS text-left"
				onClick={togglePartialSheet}
				variant={{
					title: getString('information/askQuestion/externalBankAccountDetails'),
					type: 'infoBody',
				}}
			/>
			{showPartialSheet && (
				<PartialSheet onClose={togglePartialSheet}>
					<Text className="mb-layout2XS" textStyle="headerSmall">
						<BanjoString stringId="information/giveContext/locateExternalBankDetails" />
					</Text>
					<Text textStyle="headerXS">
						<BanjoString stringId="information/giveTerm/customerPersonalCheck" />
					</Text>

					<Flex
						flexDirection="column"
						alignItems="center"
						justifyContent="center"
						data-testid="check-example"
					>
						<Image
							src={CheckExample}
							alt="Example of a check"
							aria-label="Example of a check with routing and account numbers"
						/>
					</Flex>
					<Flex>
						<div className="w-1/2">
							<Text textStyle="bodyMediumEmphasize">
								<BanjoString stringId="information/giveTerm/routingNumberExample" />
							</Text>
							<Text textStyle="bodySmallStandard" className="mt-content3XS">
								<BanjoString stringId="information/giveTerm/routingNumber" />
							</Text>
						</div>
						<div className="w-1/2">
							<Text textStyle="bodyMediumEmphasize">
								<BanjoString stringId="information/giveTerm/accountNumberExample" />
							</Text>
							<Text textStyle="bodySmallStandard" className="mt-content3XS">
								<BanjoString stringId="information/giveTerm/accountNumber" />
							</Text>
						</div>
					</Flex>
					<Text textStyle="bodySmallStandard" className="mt-contentSmall">
						<BanjoString stringId="information/answerQuestion/linkExternalBankAccount" />
					</Text>
				</PartialSheet>
			)}
		</>
	);
};

export default CheckExamplePartialSheet;
